import { Component } from '@angular/core';

@Component({
  selector: 'app-root-redirect',
  standalone: true,
  template: ''
})
export class RootRedirectComponent {
  // This component should never actually load
  // The rootGuard will redirect before it renders
}

